<template>
  <v-hover>
    <v-icon
      slot-scope="{ hover }"
      :class="{ 'elevation-4': hover }"
      class="ma-2 pa-2 award-icon"
      size="48"
      :color="color"
      @mouseover="$emit('mouseover')"
      @mouseleave="$emit('mouseleave')"
    >
      {{ icon }}
    </v-icon>
  </v-hover>
</template>

<script>
export default {
  props: ['award'],
  computed: {
    icon() {
      let type = this.award.type;
      if (type === undefined) return 'mdi-medal';
      else return 'mdi-trophy';
    },
    color() {
      let type = this.award.type;
      if (type === 'gold') return '#ffbf00';
      else if (type === 'silver') return '#c0c0c0';
      else if (type === 'bronze') return '#cd7f32';
      else return this.dark ? '#fff' : '#000';
    },
    dark() {
      return this.$vuetify._data.dark;
    },
  },
};
</script>

<style>
.award-icon {
  border-radius: 15%;
}
</style>
